import { render, staticRenderFns } from "./ArrowCompressionVIcon.vue?vue&type=template&id=23089b81&"
import script from "./ArrowCompressionVIcon.vue?vue&type=script&lang=js&"
export * from "./ArrowCompressionVIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports